import Error from "next/error"
import React from "react"
import SpacesPage from "../../features/pages/SpacesPage"
import galleryApiService from "../../services/galleryApiService"

const Spaces = ({ spaces, errorCode }) => {
  if (errorCode) {
    return <Error statusCode={errorCode} />
  }

  return <SpacesPage spaces={spaces} />
}

export const getServerSideProps = async () => {
  const response = await galleryApiService
    .spaces()
    .then((res) => {
      return res
    })
    .catch((err) => {
      return err.response
    })

  const errorCode = response.statusText == "OK" ? false : response.status

  return {
    props: {
      errorCode: errorCode,
      spaces: response.data,
    },
  }
}

export default Spaces
